export default __webpack_public_path__ + "static/media/sradar.e4d61024.svg";